let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eBwLI")).then(() => parcelRequire('7OnHY'));